<template>
  <transition name="fade">
    <div class="alert-update">
      <div>
        <div class="alert-update-section">
          <label for="severity">Severity:</label><br>
          <select id="severity" v-model="severity">
            <option value="default">default</option>
            <option value="severityhigh">severityhigh</option>
            <option value="severitymedium">severitymedium</option>
            <option value="severitylow">severitylow</option>
            <option value="lowrelevance">lowrelevance</option>
            <option value="falsepositive">falsepositive</option>
          </select>
        </div>
        <div class="alert-update-section">
          <label for="category">Category:</label><br>
          <select id="category" v-model="category">
            <option value="default">default</option>
            <option value="sensitivedisclosure">sensitivedisclosure</option>
            <option value="discussions">discussions</option>
            <option value="blackmarkets">blackmarkets</option>
            <option value="financialinformation">financialinformation</option>
            <option value="exposedcredentials">exposedcredentials</option>
            <option value="personalinformation">personalinformation</option>
            <option value="hackergrouptargeting">hackergrouptargeting</option>
            <option value="attacksandcompromises">attacksandcompromises</option>
            <option value="unidentified">unidentified</option>
          </select>

          <div class="inline" v-show="category == 'exposedcredentials'">
            <select v-model="password_type">
              <option value="encryptedpassword">encryptedpassword</option>
              <option value="cleartextpassword">cleartextpassword</option>
              <option value="internalpassword">internalpassword</option>
            </select>
            <button type="button" @click="setPassword">Set</button>
          </div>
          <div class="password" v-show="category == 'exposedcredentials'">
            {{password}}
          </div>

        </div>
        <div class="alert-update-section">
          <label for="comment">Comment:</label><br>
          <textarea id="comment" rows="4" cols="50"  v-model="comment"></textarea>
        </div>

        <div class="alert-update-section">
          <button type="button" class="btn-save" @click="cancel" aria-label="Close modal">Cancel</button>
          <button type="button" class="btn-save" @click="save" aria-label="Close modal">Save</button>
        </div>
      </div>
      <div>
        <div class="alert-update-section">
          Words or text the update is based on:
          <div class="snippet" v-for="snippet in snippets" :key="snippet">
            {{snippet}} <font-awesome-icon icon="trash" @click="removeSnippet(snippet)" title="Delete profile"/>
          </div>
          <div>
            <button type="button" @click="addSnippet">Add selected text</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-enter {
  opacity: 0;
}
.alert-update {
  display: flex;
  padding-bottom: 5px;
  background: #eeeeee;
}
.alert-update-section {
  margin-top: 5px;
  margin-left: 5px;
}
.snippet {
  font-size: small;
  margin-top: 3px;
  word-break: break-all;
  word-wrap: break-word;
}
.password {
  font-size: small;
  margin-top: 3px;
  word-break: break-all;
  word-wrap: break-word;
}
.inline {
  display: inline;
}
</style>

<script>
export default {
  name: 'AlertUpdate',
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    setPassword () {
      var text = window.getSelection().toString()
      if (text) {
        this.password = text
      }
    },
    addSnippet () {
      var text = window.getSelection().toString()
      if (text && !this.snippets.includes(text)) {
        this.snippets.push(text)
      }
    },
    removeSnippet (snippet) {
      var idx = this.snippets.findIndex(s => s === snippet)
      if (idx >= 0) this.snippets.splice(idx, 1)
    },
    cancel () {
      this.severity = this.alert.severity
      this.category = this.alert.category
      this.password = this.alert.password
      this.snippets = []
      this.comment = ''
      this.close()
    },
    save () {
      this.$store.dispatch('updateAlert', {
        alert: this.alert,
        severity: this.severity,
        category: this.category,
        snippets: this.snippets,
        password: this.password,
        password_type: this.password_type,
        comment: this.comment
      })
      this.close()
      // var params = {alert: this.alert}
      // if (this.severity != this.alert.severity) params['severity'] = this.severity
      // if (this.category != this.alert.category) params['category'] = this.category
      // if (this.snippets.length) params['snippets'] = this.snippets
      // if (this.comment) params['comment'] = this.comment
      // if (Object.keys(params).length > 1) {
      //   this.$store.dispatch('updateAlert', params)
      // }
      // this.close()
    },
    getPasswordType () {
      if (this.alert.tags.includes('encryptedpassword')) return 'encryptedpassword'
      if (this.alert.tags.includes('cleartextpassword')) return 'cleartextpassword'
      if (this.alert.tags.includes('internalpassword')) return 'internalpassword'
      return null
    }
  },
  watch: {
    alert: {
      handler () {
        this.severity = this.alert.analysis.severity
        // this.category = this.alert.analysis.category
        // this.snippets = this.alert.analysis.snippets
        // this.comment = this.alert.analysis.comment
      },
      deep: true
    }
  },
  data () {
    return {
      severity: this.alert.analysis.severity ? this.alert.analysis.severity : this.alert.severity,
      category: this.alert.analysis.category ? this.alert.analysis.category : this.alert.category,
      password: this.alert.analysis.password ? this.alert.analysis.password : this.alert.password,
      password_type: this.getPasswordType(),
      snippets: this.alert.analysis.snippets ? this.alert.analysis.snippets : [],
      comment: this.alert.analysis.comment ? this.alert.analysis.comment : '',
    }
  }
}
</script>
